import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type AuthState } from './store.type';

export interface AuthConfig {
  clientId: string;
  idpUrl: string;
}

export const initialAuthState: AuthState = {
  clientId: '',
  idpUrl: '',
  token: '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    updateToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setAuthConfig: (state, action: PayloadAction<AuthConfig>) => {
      state.idpUrl = action.payload.idpUrl;
      state.clientId = action.payload.clientId;
    },
  },
});

export const { updateToken, setAuthConfig } = authSlice.actions;

export default authSlice.reducer;
